import type { FunctionComponent, ReactNode } from "react";

interface Props {
	condition: boolean;
	children: ReactNode;
}

export const IF: FunctionComponent<Props> = ({ condition, children }) => {
	if (condition) {
		return children;
	}

	return null;
};
